// Preferencje alertów panelu. Trzymane per przeglądarka (localStorage), bo dotyczą
// stanowiska pracy, nie konta: ta sama osoba chce dzwonka na recepcji i ciszy na
// laptopie w biurze.
//
// WŁĄCZENIE powiadomień systemowych wymaga zgody przeglądarki, ale WYŁĄCZENIE jest
// w całości po naszej stronie — zgody nie da się cofnąć z kodu, więc gasimy je u siebie
// i kasujemy token push, żeby backend przestał wysyłać.

const KEYS = {
  sound: 'hs.notifications.sound',
  system: 'hs.notifications.system',
} as const;

const read = (key: string): boolean => {
  try {
    const value = localStorage.getItem(key);
    return value === null ? true : value === 'true';
  } catch {
    return true;
  }
};

const write = (key: string, value: boolean) => {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    // Brak localStorage — preferencja przeżyje tylko tę sesję.
  }
};

/** Domyślnie włączone: cisza z zaskoczenia jest gorsza niż dzwonek za dużo. */
export const isAlertSoundEnabled = (): boolean => read(KEYS.sound);
export const setAlertSoundEnabled = (value: boolean): void => write(KEYS.sound, value);

export const isSystemNotificationEnabled = (): boolean => read(KEYS.system);
export const setSystemNotificationEnabled = (value: boolean): void => write(KEYS.system, value);
